import createMutator from '../../utils/createMutator';

export const setElements = createMutator('set', 'elements');
export const setLastPage = createMutator('set', 'lastPage');